import { render, staticRenderFns } from "./fileHistory.vue?vue&type=template&id=28bad941&scoped=true&"
import script from "./fileHistory.vue?vue&type=script&lang=js&"
export * from "./fileHistory.vue?vue&type=script&lang=js&"
import style0 from "./fileHistory.vue?vue&type=style&index=0&id=28bad941&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bad941",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28bad941')) {
      api.createRecord('28bad941', component.options)
    } else {
      api.reload('28bad941', component.options)
    }
    module.hot.accept("./fileHistory.vue?vue&type=template&id=28bad941&scoped=true&", function () {
      api.rerender('28bad941', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/BillPayment/fileHistory.vue"
export default component.exports